function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
import { stateGo } from 'redux-ui-router';
import { setLockerFilter, showSubscriptionBanner } from '../../reducers/actions/customer.transactions.actions';
import { pascalCaseKeys } from '../../utilities/object.formatting.helper';
export var CLEAR_CURRENT_SUBSCRIPTION = 'CLEAR_CURRENT_SUBSCRIPTION';
export var clearCurrentSubscription = function clearCurrentSubscription() {
  return {
    type: CLEAR_CURRENT_SUBSCRIPTION
  };
};
export var CLEAR_REMOVE_ORDER_QUOTE = 'CLEAR_REMOVE_ORDER_QUOTE';
export var clearRemoveOrderQuote = function clearRemoveOrderQuote() {
  return {
    type: CLEAR_REMOVE_ORDER_QUOTE
  };
};
export var REMOVE_SUBSCRIPTION_CONSTANTS = {
  BEGIN: 'REMOVE_SUBSCRIPTION_BEGIN',
  SUCCESS: 'REMOVE_SUBSCRIPTION_SUCCESS',
  FAILURE: 'REMOVE_SUBSCRIPTION_FAILURE'
};
var REMOVE_SUBSCRIPTION_EVENTS = [REMOVE_SUBSCRIPTION_CONSTANTS.BEGIN, REMOVE_SUBSCRIPTION_CONSTANTS.SUCCESS, REMOVE_SUBSCRIPTION_CONSTANTS.FAILURE];
export var REMOVE_SUBSCRIPTION_DISCOUNT_CONSTANTS = {
  BEGIN: 'REMOVE_SUBSCRIPTION_DISCOUNT_BEGIN',
  SUCCESS: 'REMOVE_SUBSCRIPTION_DISCOUNT_SUCCESS',
  FAILURE: 'REMOVE_SUBSCRIPTION_DISCOUNT_FAILURE'
};
var REMOVE_SUBSCRIPTION_DISCOUNT_EVENTS = [REMOVE_SUBSCRIPTION_DISCOUNT_CONSTANTS.BEGIN, REMOVE_SUBSCRIPTION_DISCOUNT_CONSTANTS.SUCCESS, REMOVE_SUBSCRIPTION_DISCOUNT_CONSTANTS.FAILURE];
export var APPLY_SUBSCRIPTION_COUPON_CONSTANTS = {
  BEGIN: 'APPLY_SUSCRIPTION_COUPON_BEGIN',
  SUCCESS: 'APPLY_SUSCRIPTION_COUPON_SUCCESS',
  FAILURE: 'APPLY_SUSCRIPTION_COUPON_FAILURE'
};
var APPLY_SUBSCRIPTION_COUPON_EVENTS = [APPLY_SUBSCRIPTION_COUPON_CONSTANTS.BEGIN, APPLY_SUBSCRIPTION_COUPON_CONSTANTS.SUCCESS, APPLY_SUBSCRIPTION_COUPON_CONSTANTS.FAILURE];
export var RETRIEVE_SUBSCRIPTION_CONSTANTS = {
  BEGIN: 'RETRIEVE_SUBSCRIPTION_BEGIN',
  SUCCESS: 'RETRIEVE_SUBSCRIPTION_SUCCESS',
  FAILURE: 'RETRIEVE_SUBSCRIPTION_FAILURE'
};
var RETRIEVE_SUBSCRIPTION_EVENTS = [RETRIEVE_SUBSCRIPTION_CONSTANTS.BEGIN, RETRIEVE_SUBSCRIPTION_CONSTANTS.SUCCESS, RETRIEVE_SUBSCRIPTION_CONSTANTS.FAILURE];
export var SEARCH_SUBSCRIPTIONS_CONSTANTS = {
  BEGIN: 'SEARCH_SUBSCRIPTIONS_BEGIN',
  SUCCESS: 'SEARCH_SUBSCRIPTIONS_SUCCESS',
  FAILURE: 'SEARCH_SUBSCRIPTIONS_FAILURE'
};
var SEARCH_SUBSCRIPTIONS_EVENTS = [SEARCH_SUBSCRIPTIONS_CONSTANTS.BEGIN, SEARCH_SUBSCRIPTIONS_CONSTANTS.SUCCESS, SEARCH_SUBSCRIPTIONS_CONSTANTS.FAILURE];
export var SET_CURRENT_SUBSCRIPTION_OFFERING_DETAILS = 'SET_CURRENT_SUBSCRIPTION_OFFERING_DETAILS';
export var setCurrentSubscriptionOfferingDetails = function setCurrentSubscriptionOfferingDetails(offeringDetails) {
  return {
    type: SET_CURRENT_SUBSCRIPTION_OFFERING_DETAILS,
    payload: offeringDetails
  };
};
export var CALCULATE_REMOVE_ORDER_QUOTE_CONSTANTS = {
  BEGIN: 'CALCULATE_REMOVE_ORDER_QUOTE_BEGIN',
  SUCCESS: 'CALCULATE_REMOVE_ORDER_QUOTE_SUCCESS',
  FAILURE: 'CALCULATE_REMOVE_ORDER_QUOTE_FAILURE'
};
var CALCULATE_REMOVE_ORDER_QUOTE_EVENTS = [CALCULATE_REMOVE_ORDER_QUOTE_CONSTANTS.BEGIN, CALCULATE_REMOVE_ORDER_QUOTE_CONSTANTS.SUCCESS, CALCULATE_REMOVE_ORDER_QUOTE_CONSTANTS.FAILURE];
var removeSubscriptionPromise = function removeSubscriptionPromise(dispatch, customerId, data) {
  return ThunkHelper(dispatch, REMOVE_SUBSCRIPTION_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SubmitRemoveOrder',
    data: pascalCaseKeys(data),
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var removeSubscription = function removeSubscription(customerId, data) {
  return function (dispatch) {
    return removeSubscriptionPromise(dispatch, customerId, data);
  };
};
export var applySubscriptionCoupon = function applySubscriptionCoupon(customerId, subscriptionId, redemptionCode) {
  return function (dispatch) {
    return applySubscriptionCouponPromise(dispatch, customerId, subscriptionId, redemptionCode);
  };
};
var applySubscriptionCouponPromise = function applySubscriptionCouponPromise(dispatch, customerId, subscriptionId, redemptionCode) {
  return ThunkHelper(dispatch, APPLY_SUBSCRIPTION_COUPON_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/ApplyCoupon',
    data: {
      SubscriptionId: subscriptionId,
      RedemptionCodes: [redemptionCode]
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
var removeSubscriptionDiscountPromise = function removeSubscriptionDiscountPromise(dispatch, customerId, discountId, reasonId) {
  return ThunkHelper(dispatch, REMOVE_SUBSCRIPTION_DISCOUNT_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RemoveDiscount',
    data: {
      Id: discountId,
      Reason: reasonId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var removeSubscriptionDiscount = function removeSubscriptionDiscount(customerId, discountId, reasonId) {
  return function (dispatch) {
    return removeSubscriptionDiscountPromise(dispatch, customerId, discountId, reasonId);
  };
};
export var retrieveSubscriptionPromise = function retrieveSubscriptionPromise(dispatch, customerId, data) {
  return ThunkHelper(dispatch, RETRIEVE_SUBSCRIPTION_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveSubscription',
    data: data,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveSubscription = function retrieveSubscription(customerId, data) {
  return function (dispatch) {
    return retrieveSubscriptionPromise(dispatch, customerId, data);
  };
};
export var searchSubscriptionsPromise = function searchSubscriptionsPromise(dispatch, customerId, data) {
  return ThunkHelper(dispatch, SEARCH_SUBSCRIPTIONS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchSubscriptions',
    data: data,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var searchSubscriptions = function searchSubscriptions(customerId, data) {
  return function (dispatch) {
    return searchSubscriptionsPromise(dispatch, customerId, data);
  };
};
var calculateRemoveOrderQuotePromise = function calculateRemoveOrderQuotePromise(dispatch, customerId, data) {
  return ThunkHelper(dispatch, CALCULATE_REMOVE_ORDER_QUOTE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/CalculateRemoveOrderQuote',
    data: pascalCaseKeys(data),
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var calculateRemoveOrderQuote = function calculateRemoveOrderQuote(customerId, data) {
  return function (dispatch) {
    return calculateRemoveOrderQuotePromise(dispatch, customerId, data);
  };
};
export var SET_CURRENT_PAGE = 'SET_SUBSCRIPTIONS_CURRENT_PAGE';
export var setCurrentPage = function setCurrentPage(page) {
  return {
    type: SET_CURRENT_PAGE,
    payload: page
  };
};
export var SET_SUBSCRIPTIONS_PAGE_SIZE_PREFERENCE = 'SET_SUBSCRIPTIONS_PAGE_SIZE_PREFERENCE';
export var setPageSizePreference = function setPageSizePreference(pageSize) {
  return {
    type: SET_SUBSCRIPTIONS_PAGE_SIZE_PREFERENCE,
    payload: pageSize
  };
};
export var SET_INCLUDED_FILTER = 'SET_SUBSCRIPTIONS_INCLUDED_FILTER';
export var setIncludedFilter = function setIncludedFilter(includedFilter) {
  return {
    type: SET_INCLUDED_FILTER,
    payload: includedFilter
  };
};
export var SET_SELECTED_DISCOUNT = 'SET_SELECTED_DISCOUNT';
export var setSelectedDiscount = function setSelectedDiscount(discount) {
  return {
    type: SET_SELECTED_DISCOUNT,
    payload: discount
  };
};
export var SET_SUBSCRIPTION_COUPON_CODE = 'SET_SUBSCRIPTION_COUPON_CODE';
export var setSubscriptionCouponCode = function setSubscriptionCouponCode() {
  var couponCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: SET_SUBSCRIPTION_COUPON_CODE,
    payload: couponCode
  };
};
export var SET_EDIT_RENEWAL = 'SET_EDIT_RENEWAL';
export var setEditRenewal = function setEditRenewal(renewalUnderEdit) {
  return {
    type: SET_EDIT_RENEWAL,
    payload: renewalUnderEdit
  };
};
export var UPDATE_SUBSCRIPTION_CONSTANTS = {
  BEGIN: 'UPDATE_SUBSCRIPTION_BEGIN',
  SUCCESS: 'UPDATE_SUBSCRIPTION_SUCCESS',
  FAILURE: 'UPDATE_SUBSCRIPTION_FAILURE'
};
export var RETRIEVE_PENDING_ORDER_CONSTANTS = {
  BEGIN: 'RETRIEVE_PENDING_ORDER_BEGIN',
  SUCCESS: 'RETRIEVE_PENDING_ORDER_SUCCESS',
  FAILURE: 'RETRIEVE_PENDING_ORDER_FAILURE'
};
export var SET_EDIT_SUBSCRIPTION_ITEM_ID = 'SET_EDIT_SUBSCRIPTION_ITEM_ID';
export var setEditSubscriptionItemId = function setEditSubscriptionItemId() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: SET_EDIT_SUBSCRIPTION_ITEM_ID,
    payload: id
  };
};
export var SET_MODIFY_RENEWAL_SUBSCRIPTION_ITEM = 'SET_MODIFY_RENEWAL_SUBSCRIPTION_ITEM';
export var setModifyRenewalSubscriptionItem = function setModifyRenewalSubscriptionItem() {
  var subscriptionItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return {
    type: SET_MODIFY_RENEWAL_SUBSCRIPTION_ITEM,
    payload: subscriptionItem
  };
};
var UPDATE_SUBSCRIPTION_EVENTS = [UPDATE_SUBSCRIPTION_CONSTANTS.BEGIN, UPDATE_SUBSCRIPTION_CONSTANTS.SUCCESS, UPDATE_SUBSCRIPTION_CONSTANTS.FAILURE];
var updateSubscriptionPromise = function updateSubscriptionPromise(dispatch, customerId, data) {
  return ThunkHelper(dispatch, UPDATE_SUBSCRIPTION_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/UpdateSubscription',
    data: data,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
var RETRIEVE_PENDING_ORDER_EVENTS = [RETRIEVE_PENDING_ORDER_CONSTANTS.BEGIN, RETRIEVE_PENDING_ORDER_CONSTANTS.SUCCESS, RETRIEVE_PENDING_ORDER_CONSTANTS.FAILURE];
var retrievePendingOrderCancellationPromise = function retrievePendingOrderCancellationPromise(dispatch, customerId, data) {
  return ThunkHelper(dispatch, RETRIEVE_PENDING_ORDER_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrievePendingOrderCancellationContext',
    data: data,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
var cancelPendingOrderPromise = function cancelPendingOrderPromise(dispatch, customerId, data) {
  return ThunkHelper(dispatch, UPDATE_SUBSCRIPTION_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/CancelPendingOrder',
    data: data,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var updateSubscription = function updateSubscription(customerId, data) {
  return function (dispatch) {
    return updateSubscriptionPromise(dispatch, customerId, data);
  };
};
export var retrievePendingOrder = function retrievePendingOrder(customerId, data) {
  return function (dispatch) {
    return retrievePendingOrderCancellationPromise(dispatch, customerId, data);
  };
};
export var cancelPendingOrder = function cancelPendingOrder(customerId, data) {
  return function (dispatch) {
    return cancelPendingOrderPromise(dispatch, customerId, data);
  };
};
export var viewSubscriptionTransactions = function viewSubscriptionTransactions(previousRoute, subscription) {
  return function (dispatch) {
    dispatch(showSubscriptionBanner(true));
    dispatch(setLockerFilter(subscription.Items[0].Id));
    dispatch(stateGo('index.customercare.customer.transactions.list', {
      previousRoute: previousRoute,
      subscription: subscription
    }));
  };
};
export var EMPTY_SUBSCRIPTIONS_LIST = 'EMPTY_SUBSCRIPTIONS_LIST';
export var emptySubscriptionsList = function emptySubscriptionsList() {
  return {
    type: EMPTY_SUBSCRIPTIONS_LIST
  };
};
export var REMOVE_SUBSCRIPTIONS_FILTER = 'REMOVE_SUBSCRIPTIONS_FILTER';
export var removeSubscriptionsFilter = function removeSubscriptionsFilter() {
  return {
    type: REMOVE_SUBSCRIPTIONS_FILTER
  };
};